module.exports = __webpack_public_path__ + "img/BM_Manager.4267d2bf.svg";